import { useLayoutEffect, type RefObject } from 'react';
import { AppBarStyles } from '@client/style/style.constants';

/** Keep the view switch beneath the avatar, hiding it before the controls touch. */
export const useProjectViewSwitchPosition = (
  enabled: boolean,
  profileRef: RefObject<HTMLDivElement | null>,
  switchRef: RefObject<HTMLDivElement | null>,
) => {
  useLayoutEffect(() => {
    const profile = profileRef.current;
    const viewSwitch = switchRef.current;
    const toolbar = viewSwitch?.parentElement;
    const header = toolbar?.closest<HTMLElement>('[data-app-header]');
    if (!enabled || !profile || !viewSwitch || !toolbar || !header) return;

    const update = () => {
      const profileBounds = profile.getBoundingClientRect();
      const toolbarBounds = toolbar.getBoundingClientRect();
      toolbar.style.setProperty(
        '--project-list-profile-center-right',
        `${toolbarBounds.right - profileBounds.left - profileBounds.width / 2}px`,
      );
      const switchBounds = viewSwitch.getBoundingClientRect();
      viewSwitch.style.visibility =
        header.getBoundingClientRect().height > AppBarStyles.HEIGHT &&
        profileBounds.width > 0 &&
        switchBounds.height > 0 &&
        switchBounds.top >= profileBounds.bottom + 8
          ? 'visible'
          : 'hidden';
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(header);
    observer.observe(profile);
    observer.observe(viewSwitch);
    return () => {
      observer.disconnect();
      toolbar.style.removeProperty('--project-list-profile-center-right');
      viewSwitch.style.removeProperty('visibility');
    };
  }, [enabled, profileRef, switchRef]);
};
